module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "sidebar-menu",
    style: ({
      backgroundColor: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "dark": "",
      "fixed": "",
      "value": true,
      "mobile-break-point": 768,
      "clipped": true
    }
  }, [_c('v-list', {
    staticClass: "menu_list_data",
    attrs: {
      "dark": ""
    }
  }, _vm._l((_vm.items), function(item, i) {
    return (item.children) ? _c('v-list-group', {
      key: i,
      attrs: {
        "value": _vm.isOpen(item.link)
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "color": "grey"
      },
      slot: "activator"
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(sub_item, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "router": "",
          "to": sub_item.query ? ((sub_item.link) + "/" + (sub_item.query.page)) : ("" + (sub_item.link))
        }
      }, [_c('v-list-tile-action', [_c('v-icon', {
        staticClass: "menu_list_item_data",
        attrs: {
          "color": "white"
        }
      }, [_vm._v(_vm._s(sub_item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
        staticClass: "white--text menu_list_item_data"
      }, [_vm._v("\n            " + _vm._s(sub_item.text) + "\n          ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "router": "",
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-060504ef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Components/AdminSideBar.vue
// module id = 846
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11